import { Card, Chip, Link, Stack, styled, SxProps, Typography } from "@mui/material";
import MetadataListItem from "../../Misc/Metadata/MetadataListItem";
import MetadataListTextItem from "../../Misc/Metadata/MetadataListTextItem/metadata-list-text-item";
import { useTranslation } from "react-i18next";

export interface AssetHeroBypassingCardProps {
  sx?: SxProps;
  bypassDetails: any;
}

const AssetHeroBypassingCard: React.FC<AssetHeroBypassingCardProps> = (props) => {
  const { t } = useTranslation();
  const { sx = {}, bypassDetails } = props;

  return (
    <StyledCard variant="outlined" sx={sx}>
      <Stack direction="row" justifyContent="space-between">
        <MainContent justifyContent="space-between" spacing={2}>
          <div>
            <Typography sx={{ mb: 1 }} fontWeight={600} variant="subtitle2">
              {t("component:asset.body.bypassDetails")}
            </Typography>
            <Typography color="warning.main">{bypassDetails.bypassedComment}</Typography>
          </div>
          <Stack spacing={1}>
            <MetadataListItem title={t("menu:title.lowerCaseBypassedBy")}>
              {bypassDetails.bypassedBy !== "System" ? (
                <Link href="#" underline="hover" fontWeight={500}>
                  {bypassDetails.bypassedBy}
                </Link>
              ) : (
                bypassDetails.bypassedBy
              )}
            </MetadataListItem>
            <MetadataListTextItem title={t("menu:title.lowerCaseBypassedAt")}>
              {bypassDetails.bypassedAt}
            </MetadataListTextItem>
            <MetadataListItem title={t("common:provider")}>
              <Chip size="small" color="info" label={bypassDetails.assignedProviderName} />
            </MetadataListItem>
          </Stack>
        </MainContent>
      </Stack>
    </StyledCard>
  );
};

export default AssetHeroBypassingCard;

const StyledCard = styled(Card)(({ theme }) => ({
  padding: `${theme.spacing(3)} ${theme.spacing(5)} ${theme.spacing(3)} ${theme.spacing(3)}`,
  background: "linear-gradient(180deg, rgba(255, 179, 0, 0.05) 0%, rgba(255, 179, 0, 0) 100%)",
}));

const MainContent = styled(Stack)(() => ({
  flex: "1 1 auto",
}));
